<template>
  <div style="width:100%;height:100%;overflow: hidden;position: fixed">
    <div
      :style="[
        $vuetify.breakpoint.height >= 680
          ? { height: '12%' }
          : { height: '16%' }
      ]"
    >
    <search :havetype="uniquetype" ref="searchComponent" @filter="filterData"/>
    </div>
    <div :style="coverStyle">
      <longdo-map @load="initMap" />
    </div>
    <v-row class="d-flex align-center py-0 result-header" @click="toggleresult">
      <v-col cols="2"></v-col>
      <v-col class="py-1 text-center" style="font-size: large">
        <span class="pink--text" data-testid="resultpanelheader"
          ><b>จุดบริการใกล้คุณ</b></span
        >
      </v-col>
      <v-col
        cols="3"
        class="py-1 d-flex align-baseline"
        style="color: gray"
        data-testid="toggleResult"
      >
        <v-icon small>{{
          resultpanel ? "mdi-arrow-collapse-down" : "mdi-arrow-collapse-up"
        }}</v-icon>
        <span>{{ resultpanel ? "ซ่อน" : "แสดง" }}</span>
      </v-col>
    </v-row>
    <div
      v-show="resultpanel"
      class="pt-4"
      style="overflow-y: scroll;overflow-x: hidden"
      :style="[
        $vuetify.breakpoint.height >= 680
          ? { height: '32%' }
          : { height: '28%' }
      ]"
      data-testid="resultPanel"
    >
      <result :result="resultList" @gotoLocation="changeMapLocation" />
    </div>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          กำลังโหลดข้อมูล
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Result from './result.vue'
import Search from './search.vue'
export default {
  name: 'home',
  components: {
    Search,
    Result
  },
  computed: {
    coverStyle () {
      const styleObj = {}
      if (this.resultpanel) {
        styleObj.height = '54%'
      } else {
        if (this.$vuetify.breakpoint.height >= 680) {
          styleObj.height = '85%'
        } else {
          styleObj.height = '80%'
        }
      }
      return styleObj
    },
    axios () {
      return require('axios')
    }
  },
  mounted () {},
  data: () => ({
    loading: true,
    map: {},
    uniquetype: [],
    resultpanel: true,
    chipObject: [
      {
        icon: 'icon01.png',
        iconsize: 32,
        text: 'บริษัทกลาง',
        tel: 1791
      },
      {
        icon: 'icon11.png',
        iconsize: 28,
        text: 'เหตุด่วน เหตุร้าย',
        tel: 191
      },
      {
        icon: 'icon10.png',
        iconsize: 28,
        text: 'เจ็บป่วย ฉุกเฉิน',
        tel: 1669
      }
    ],
    resultList: [],
    serviceResponse: [],
    markerList: [],
    geoLocation: {
      lat: 0,
      lon: 0
    }
  }),
  methods: {
    initMap (map) {
      this.map = map
      this.getDataFromService()
      // this.map.Ui.Scale.visible(false);
      this.map.Ui.Toolbar.visible(false)
      this.map.Ui.Toolbar.visible(false)
      this.map.Ui.DPad.visible(false)
      this.map.Ui.Zoombar.visible(false)
      this.map.Ui.Geolocation.visible(false)
      this.map.Ui.LayerSelector.visible(false)
      const searchThisAreaContaoinerr = document.querySelector('.ldmap_topleft.ldmap_maparea')
      searchThisAreaContaoinerr.innerHTML = `<div class="d-flex">
          <div id="searchBtn">ค้นหาบริเวณนี้</div>
        </div>`
      const mapToolContainer = document.querySelector(
        '.ldmap_topright.ldmap_maparea'
      )
      mapToolContainer.innerHTML = `<div class="d-flex flex-column maptool">
          <div id="geoLocation">
            <span class="mdi mdi-crosshairs-gps"></span>
          </div>
          <div id="zoomIn">
            <span class="mdi mdi-plus"></span>
          </div>
          <div  id="zoomOut">
            <span class="mdi mdi-minus"></span>
          </div>
        </div>`
      document.querySelector('#zoomIn').addEventListener('click', () => {
        this.map.zoom(true)
      })
      document.querySelector('#zoomOut').addEventListener('click', () => {
        this.map.zoom(false)
      })
      document.querySelector('#geoLocation').addEventListener('click', () => {
        this.map.location(window.longdo.LocationMode.Geolocation)
      })
      document.querySelector('#searchBtn').addEventListener('click', () => {
        this.refreshKM(this.serviceResponse)
        this.$refs.searchComponent.clearSearch()
        document.querySelector('#searchBtn').style.display = 'none'
      })
      this.map.Event.bind('drop', () => {
        document.querySelector('#searchBtn').style.display = 'flex'
      })
      this.map.Event.bind('geolocation', () => {
        document.querySelector('#searchBtn').style.display = 'none'
        this.refreshKM(this.serviceResponse)
        this.loading = false
      })
      this.map.Event.bind('geolocationError', () => {
        document.querySelector('#searchBtn').style.display = 'none'
        this.refreshKM(this.serviceResponse)
        this.loading = false
      })
      let chipelement = ''
      for (let index = 0; index < this.chipObject.length; index++) {
        const element = this.chipObject[index]
        chipelement += `
        <div class="d-flex chipstyle mb-1 mx-1 px-2 py-1" onclick="window.open('tel:${
          element.tel
        }', '_self');">
          <div class="d-flex align-center">
            <img width=${element.iconsize} src="${require('@/assets/icon/' +
          element.icon)}" />
          </div>
          <div class="d-flex flex-column">
            <div class="px-1 purple--text" style="white-space: nowrap;"><b>${
              element.text
            }</b></div>
            <div align="center" style="font-size: large"><span class="mdi mdi-phone-in-talk"></span><b> ${
              element.tel
            }</b></div>
          </div>
        </div>`
      }

      document.querySelector('.ldmap_bottomleft.ldmap_maparea').innerHTML = `
      <div class="d-flex" style="overflow-x:scroll;width:98vw;">
        ${chipelement}
      </div>`
    },
    toggleresult () {
      this.resultpanel = !this.resultpanel
    },
    filterText (text) {
      this.clearMarker()
      // this.resultList = this.serviceResponse.filter(element => element.name.includes(text)).slice(0, 10)
      // this.createMarker(this.resultList)
      this.axios.get("https://search.longdo.com/mapsearch/json/search", {
        params: {
          key: "rvp-dashboard",
          keyword: text
        }
      })
        .then(res => {
          if (res.status === 200 && res.data) {
            const { data } = res.data
            this.map.location(
              {
                lat: data[0].lat,
                lon: data[0].lon
              }
            )
            setTimeout(() => {
              this.refreshKM(this.serviceResponse)
            }, 700)
          }
        })
    },
    filterType (type) {
      this.clearMarker()
      this.resultList = this.serviceResponse.filter(element => element.type === type).slice(0, 10)
      // this.resultList.sort((a, b) => (a.km > b.km ? 1 : b.km > a.km ? -1 : 0))
      // this.createMarker(this.resultList)
      this.refreshKM(this.resultList)
    },
    filterData (filterObj) {
      this.clearMarker()
      // if (filterObj.searchText && filterObj.typeSelect) {
      //   this.resultList = this.serviceResponse.filter(element => element.type === filterObj.typeSelect && element.name.includes(filterObj.searchText)).slice(0, 10)
      //   this.createMarker(this.resultList)
      // } else if (filterObj.searchText) {
      //   this.filterText(filterObj.searchText)
      // } else if (filterObj.typeSelect) {
      //   this.filterType(filterObj.typeSelect)
      // }
      if (filterObj.searchText) {
        this.axios.get("https://search.longdo.com/mapsearch/json/search", {
          params: {
            key: "rvp-dashboard",
            keyword: filterObj.searchText
          }
        })
          .then(res => {
            if (res.status === 200 && res.data) {
              const { data } = res.data
              this.map.location(
                {
                  lat: data[0].lat,
                  lon: data[0].lon
                }
              )
              setTimeout(() => {
                this.refreshKM(this.serviceResponse)
                if (filterObj.typeSelect) {
                  this.filterType(filterObj.typeSelect)
                }
              }, 700)
            }
          })
      } else if (filterObj.typeSelect) {
        this.filterType(filterObj.typeSelect)
      }
    },
    getDataFromService () {
      this.axios
        .post("https://placeapi.rvpeservice.com/api/place/PlaceNearby")
        .then(res => {
          if (res.status === 200 && res.data) {
            const List = []
            for (let index = 0; index < res.data.Data.Place.length; index++) {
              const element = res.data.Data.Place[index]
              let icon = 'icon0' + (Math.floor(Math.random() * 9) + 1) + '.png'
              switch (element.type) {
                case 'RVP': icon = 'icon01.png'
                  break
                case 'Hospital': icon = 'icon07.png'
                  break
                case 'Insurance Agent': icon = 'icon02.png'
                  break
                case 'Vehicle Inspection Center': icon = 'icon05.png'
                  break
                case 'Motorcycle dealers': icon = 'icon06.png'
                  break
              }
              List.push({
                logo: icon,
                name: element.name,
                km: Number(
                  this.calculateKM(
                    parseFloat(element.lat),
                    parseFloat(element.lon),
                    this.map.location().lat,
                    this.map.location().lon
                  )
                ),
                lat: element.lat,
                lon: element.lon,
                address: element.address,
                tel: element.tel,
                type: element.type
              })
            }
            // List.sort((a, b) => (a.km > b.km ? 1 : b.km > a.km ? -1 : 0))
            this.serviceResponse = List
            this.uniquetype = [...new Set(List.map(item => item.type))]
            // this.refreshKM(this.serviceResponse)
            this.map.location(window.longdo.LocationMode.Geolocation)
          }
        })
    },
    refreshKM (List) {
      this.clearMarker()
      List.forEach(element => {
        element.km = Number(
          this.calculateKM(
            parseFloat(element.lat),
            parseFloat(element.lon),
            this.map.location().lat,
            this.map.location().lon
          )
        )
      })
      List.sort((a, b) => (a.km > b.km ? 1 : b.km > a.km ? -1 : 0))
      this.resultList = List.slice(0, 10)
      this.createMarker(this.resultList)
    },
    createMarker (List) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index]
        const marker = new window.longdo.Marker(
          { lon: element.lon, lat: element.lat },
          {
            title: element.name,
            detail: element.adderss,
            icon: {
              html: `<img style="background-color:white;border-radius:100%" width="36" src="${require('@/assets/icon/' + element.logo)}">`,
              offset: { x: 17.5, y: 16 }
            },
            // popup: {
            //   html: `<div style="font-family: 'Sarabun'" class="d-flex flex-column pa-2">
            //     <span style="font-size:large">${element.name}</span>
            //     <span style="font-size: small">ที่อยู่ ${element.address}</span>
            //     <span style="font-size: small">เบอร์โทรศัพท์ ${element.tel}</span>
            //   </div>`
            // },
            draggable: false,
            weight: window.longdo.OverlayWeight.Top,
            closable: true
          }
        )
        this.markerList.push(marker)
        this.map.Overlays.add(marker)
      }
    },
    clearMarker () {
      this.markerList.forEach(element => {
        this.map.Overlays.remove(element)
      })
      this.markerList.pop = []
    },
    changeMapLocation (locationObj) {
      this.map.location(locationObj)
    },
    calculateKM (lat1, lon1, lat2, lon2) {
      var R = 6371 // km
      var dLat = this.toRad(lat2 - lat1)
      var dLon = this.toRad(lon2 - lon1)
      var xlat = this.toRad(lat1)
      var xlat2 = this.toRad(lat2)

      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
          Math.sin(dLon / 2) *
          Math.cos(xlat) *
          Math.cos(xlat2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return d
    },
    toRad (Value) {
      return (Value * Math.PI) / 180
    }
  },
  watch: {}
}
</script>

<style scope>
.result-header {
  border-style: solid;
  border-width: 0px 0px 2px 0px;
  border-color: purple;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  /* margin-top: -12px; */
  z-index: 1;
  background-color: white;
  position: relative;
  font-family: "Prompt";
}
.ldmap_notice {
  margin-bottom: 9px;
}
.ldmap_placeholder .ldmap_bottomleft {
  bottom: 12px !important;
}
.chipstyle {
  background-color: white;
  border-radius: 20px;
  font-family: "Sarabun";
}
.maptool div {
  background-color: white;
  border-radius: 100%;
  font-size: x-large;
  padding: 8px;
  margin: 4px;
  color: rgb(44, 127, 233);
  box-shadow: 2px 2px #888888;
  cursor: pointer;
}
.ldmap_placeholder .ldmap_topleft {
  width: 100%;
  left: 0px !important;
  padding: 0px !important;
  display: flex;
  justify-content: center;
  background-color: transparent !important;
  z-index: 6 !important;
}
#searchBtn {
  background-color: white;
  padding: 12px 12px;
  box-shadow: 1px 1px 1px 1px #888888;
  color: rgb(44, 127, 233);
  border-radius: 16%;
  font-family: "Sarabun";
  cursor: pointer;
  display: none;
  font-size: small;
}
</style>
